import { RETURNS_CHALLAN_COLUMNS } from '../../../../constants/returnsStep'
import { getChallanColumns } from '../../../../hooks/useRetursChallan'
import CommonTable from '../../../common/CommonTable'

function ReturnsChallan({ editMode, challanHook, formVersion, financialYear, formType }) {
  // Use version-aware column selection
  const columns = formVersion === 'new'
    ? getChallanColumns(financialYear, formType)
    : RETURNS_CHALLAN_COLUMNS

  return (
    <CommonTable
      columns={columns}
      data={challanHook.challanData}
      loading={challanHook.challanDataLoading}
      editMode={editMode}
      showCheckbox={false}
      selectedItems={challanHook.selectedRows}
      onSelectItem={id =>
        challanHook.setSelectedRows(prev =>
          prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        )
      }
      onSelectAll={e =>
        challanHook.setSelectedRows(
          e.target.checked ? challanHook.challanData.map(r => r.uuid) : []
        )
      }
      onFieldChange={challanHook.handleFieldChange}
      onPageChange={challanHook.handlePageChange}
      onItemsPerPageChange={challanHook.handleItemsPerPageChange}
      totalItems={challanHook.totalItems}
      editingData={challanHook.editingData}
      currentPage={challanHook.currentPage}
      itemsPerPage={challanHook.itemsPerPage}
      showFooter={true}
      showActions={false}
    />
  )
}

export default ReturnsChallan
